import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const CardContainer = styled.div<{ $height?: string; $isBorderless?: boolean; $width?: string }>`
  ${({ $height }) => ($height ? `height: ${$height};` : '')}
  ${({ $width }) => ($width ? `width: ${$width};` : '')}
  align-self: stretch;
  background: ${Colors.white};
  border-radius: ${BorderRadius.Xs};

  display: flex;
  flex-direction: column;

  ${({ $isBorderless }) =>
    $isBorderless
      ? `padding: 0.0 0;`
      : `border: 1px solid ${Colors.blue[20]};
        padding: ${Spacing.Xs} ${Spacing.S};`}

  &:hover {
    background: ${Colors.blue[5]};
    cursor: pointer;
  }
`;
